import PropTypes from 'prop-types';
import React from 'react';

import { HtmlContentLoader } from '@powdr/components';

import { StyledFormTripleseat } from './styles';

export const FormTripleseat = ({
  className = '',
  parentColorProfile,
  formID,
  publicKey,
}) => {
  const script = `<script src="https://api.tripleseat.com/v1/leads/ts_script.js?lead_form_id=${formID}&public_key=${publicKey}" type="text/javascript"></script>`;

  if (!formID || !publicKey) return null;

  return (
    <StyledFormTripleseat
      className={className}
      $colorProfile={parentColorProfile}
    >
      <HtmlContentLoader html={script} allowRerender />
    </StyledFormTripleseat>
  );
};

FormTripleseat.propTypes = {
  className: PropTypes.string,
  parentColorProfile: PropTypes.string.isRequired,
  formID: PropTypes.string.isRequired,
  publicKey: PropTypes.string.isRequired,
};
